


























import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import forIn from "lodash/forIn";
import XlsApi from "@/api/Xls";

import SelectControl from "@/components/Controls/SelectControl.vue";

const _ = { forIn };
const AppStore = namespace("App");

@Component({
  name: "ReportAdmin",
  components: {
    SelectControl
  }
})
export default class ReportAdmin extends Vue {
  @AppStore.State
  organizations!: any;

  public selectedOrganization: string = "";

  get reportUrl() {
    return XlsApi.getPreliminaryReportUrl(this.selectedOrganization);
  }

  get organizationsForSelect() {
    const orgs: Array<OrganizationList> = [];
    _.forIn(this.organizations, (v: string, k: string) =>
      orgs.push({ id: k, name: v })
    );
    return orgs;
  }

  created() {
    this.selectedOrganization = this.$store.state.User.user.organization;
  }
}
